<script>
import {
  produitsIncompatiblesFormEmits,
  produitsIncompatiblesFormProps,
  useProduitsIncompatiblesForm
} from "./mixin";
import GridCol from "@/components/molecules/grid/grid-col";
import GridRow from "@/components/molecules/grid/grid-row";
import Divider from "@/components/atoms/divider/index";
import LazyImage from "@/components/atoms/lazy-image";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";
import ButtonIcon from "@/components/molecules/button-icon";
import List from "@/components/molecules/list";
import ListItem from "@/components/molecules/list/list-item";
import ShippingMethodEligibility from "@/containers/shipping-method-eligibility";

export default {
  name: "ProduitsIncompatiblesForm",
  components: {
    Button,
    List,
    Icon,
    ButtonIcon,
    ListItem,
    Divider,
    GridCol,
    GridRow,
    LazyImage,
    ShippingMethodEligibility
  },
  props: {
    ...produitsIncompatiblesFormProps()
  },
  emits: [
    "deleteProduitsIncompatibles",
    "putProduitsIncompatiblesInListe",
    "cancel",
    ...produitsIncompatiblesFormEmits()
  ],
  setup(props, context) {
    const { deleteProduitsIncompatibles, iconName } =
      useProduitsIncompatiblesForm(props, context);
    return { deleteProduitsIncompatibles, iconName };
  }
};
</script>

<template>
  <div>
    <p class="u-mb-sm u-text-center">
      <Icon
        class="u-inline-flex"
        size="xlg"
        :name="iconName"
      />
    </p>
    <h3 class="u-font-24 u-color-primary u-mt-md u-text-center u-mb-sm">
      Le service de {{ modeCommande.label_long }} n'est pas disponible pour tous <br>les produits de votre commande
    </h3>
    <p class="u-font-15 u-color-grey-1 u-mb-lg u-text-center">
      Vous souhaitez tout de même choisir ce mode ?<br>
      Vous pouvez mettre de côté {{ pluralize(produitsIncompatibles.length, 'ce') }} {{ pluralize(produitsIncompatibles.length, 'produit') }} dans une liste pour {{ pluralize(produitsIncompatibles.length, 'le') }} commander juste après !
    </p>
    <List>
      <ListItem
        v-for="produit in produitsIncompatibles"
        :key="produit.id"
      >
        <p class="u-mr-xlg u-ml-xlg">
          <Divider dotted />
        </p>
        <GridRow class="u-flex-align-center u-pt-sm u-pb-sm o-row--no-gutter">
          <GridCol class="o-col--1 o-col--no-gutter">
            <LazyImage
              :dimension="64"
              :src="produit.produit.data.attributes.visuel"
              width="64"
              height="64"
            />
          </GridCol>
          <GridCol class="o-col--4">
            <p class="u-font-15 u-font-500">
              {{ produit.designation }}
            </p>
          </GridCol>
          <GridCol class="o-col--3 o-col--no-gutter">
          </GridCol>
          <GridCol class="o-col--1 o-col--no-gutter u-text-center">
            <div>
              <p class="u-font-16 u-font-700 u-color-secondary">
                {{ formatPrix(produit.prix) }} €
              </p>
            </div>
          </GridCol>
          <GridCol class="o-col--3 o-col--no-gutter">
            <ShippingMethodEligibility
              :unavailable-services="produit.produit.data.attributes.unavailable_services"
              class="u-flex u-flex-row u-flex-justify-end"
              infobulle
              open-on-hover
              inner-class="u-mr-xxs"
            />
          </GridCol>
        </GridRow>
      </ListItem>
    </List>
    <div class="u-full-width u-inline-flex u-flex-justify-center u-mt-xlg u-mb-md u-pt-sm ">
      <Button
        size="md"
        outline
        radius="full"
        variant="primary"
        class="u-mr-sm"
        @click="$emit('deleteProduitsIncompatibles')"
      >
        Supprimer {{ pluralize(produitsIncompatibles.length, 'ce') }} {{ pluralize(produitsIncompatibles.length, 'produit') }}
      </Button>
      <ButtonIcon
        icon-name="mes-listes"
        radius="full"
        variant="primary"
        size="md"
        icon-color="white"
        icon-size="sm"
        class="u-ml-sm"
        @click="$emit('putProduitsIncompatiblesInListe')"
      >
        Mettre de côté dans une liste
      </ButtonIcon>
    </div>
    <p class="u-mb-md u-text-center">
      <Button
        link
        @click="$emit('cancel')"
      >
        Choisir un autre mode de livraison
      </Button>
    </p>
  </div>
</template>
